import React from 'react'

interface EmptyLabelProps {
  className?: string
}

const EmptyLabel: React.FC<EmptyLabelProps> = (props): React.ReactElement => {
  return <span className={props.className}>{'- -'}</span>
}

export default EmptyLabel
